/**
 * CV Types
 */
export const LOAD_CV_SUCCESS = 'LOAD_CV_SUCCESS'
export const CV_LOADING = 'CV_LOADING'
